// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ExploitableIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.22 14.43V7.5c0-.73.42-1.4 1.08-1.72l5.18-2.58a2 2 0 0 1 1.72 0l5.11 2.58c.65.32 1.07 1 1.07 1.72v6.93c0 1.45-1.11 2.83-2.52 3.92-1.92 1.5-4.32 2.46-4.32 2.46a.6.6 0 0 1-.48 0s-2.4-.97-4.33-2.46c-1.4-1.09-2.51-2.47-2.51-3.92m1.29 0c0 1.1.94 2.08 2.01 2.9a19 19 0 0 0 3.78 2.19c.62-.28 2.34-1.07 3.77-2.18 1.07-.83 2.02-1.81 2.02-2.91V7.5a.6.6 0 0 0-.36-.57l-5.1-2.57a.6.6 0 0 0-.58 0L6.87 6.92a.6.6 0 0 0-.36.57zm5.67-1.62-1.25 1.25a.64.64 0 0 1-.9-.9l1.24-1.26-1.13-1.14a.64.64 0 0 1 .9-.9l1.14 1.13 1.25-1.25a.64.64 0 0 1 .91.9L13.1 11.9l1.37 1.36a.64.64 0 0 1-.91.91z"
      clipRule="evenodd"
    />
  </svg>,
  "Exploitable",
);
export default ExploitableIcon;
